import React, { useState } from 'react';
import { withTranslation, useTranslation } from 'react-i18next';
import { Formik, Form, Field } from 'formik';
import Input from '@hobs/components/Input';
import { GhostButton, RaisedButton } from '@hobs/components/Buttons';
import PropTypes from 'prop-types';
import { H5 } from '@hobs/components/Headings';
import InputLabel from '@hobs/components/InputLabel';
import Switch from '@hobs/components/Switch';

import './UserPasswordManager.scss';
import Confirm from '@hobs/components/Confirm';
import { connect } from 'react-redux';

const UserPasswordManager = ({
  resetPasswordSchema,
  user,
  onResetPasswordSubmit,
  onResendPasswordSubmit,
  onPasswordLockChange,
  onUserDeleted,
  resendDisabled,
  currentUserId
}) => {
  const { t } = useTranslation();
  const [isChangeSubmitting, setIsChangeSubmitting] = useState(false);

  if (!user) {
    return (<div></div>);
  }

  return (
    <div className="user-password-manager-view">
      <div className="user-password-manager-view--column">
        <Formik
          validateOnBlur={false}
          validateOnChange={false}
          validationSchema={resetPasswordSchema}
          enableReinitialize={true}
          initialValues={{
            password: '',
            confirmPassword: ''
          }}
          onSubmit={onResetPasswordSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <H5>{t('Change password')}</H5>
              <Field
                name="password"
                type="password"
                component={Input}
                autoComplete="off"
                disabled={user.isDeleted}
              >
                {t('Password')}
              </Field>
              <Field
                name="confirmPassword"
                type="password"
                component={Input}
                autoComplete="off"
                disabled={user.isDeleted}
              >
                {t('Confirm password')}
              </Field>
              <RaisedButton type="submit" disabled={isSubmitting || user.isDeleted}>
                {t('Change')}
              </RaisedButton>
            </Form>
          )}
        </Formik>
      </div>
      <div className="user-password-manager-view--column">
        <H5>{t('Resend password')}</H5>
        <InputLabel>{t('Email')}</InputLabel>
        <div className="user-password-manager-view--info">{user.email}</div>
        <RaisedButton
          onClick={onResendPasswordSubmit}
          disabled={resendDisabled || user.isDeleted}
        >
          {t('Resend')}
        </RaisedButton>
        <div className="user-password-manager-lock">
          <H5>{t('Account')}</H5>
          <div>
            <Switch
              checked={user.isPasswordLocked}
              onChange={isLocked => {
                onPasswordLockChange(isLocked);
              }}
              label={t(user.isPasswordLocked ? 'Locked' : 'Unlocked')}
              disabled={user.isDeleted}
            />
            {currentUserId !== user.userId && (
              <GhostButton
                danger
                size={"small"}
                disabled={isChangeSubmitting || user.isDeleted}
                onClick={() => {
                  Confirm(
                    t('Delete user'),
                    t(
                      'Are you sure, you want to delete this user? This action cannot be undone'
                    ),
                    () => {
                        onUserDeleted((isSubmitting) => setIsChangeSubmitting(isSubmitting))
                    }
                  )}}
              >
                {user.isDeleted ? 'Deleted' : 'Delete'}
              </GhostButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

UserPasswordManager.propTypes = {
  t: PropTypes.func,
  user: PropTypes.object,
  resetPasswordSchema: PropTypes.object,
  onResetPasswordSubmit: PropTypes.func,
  onResendPasswordSubmit: PropTypes.func,
  onPasswordLockChange: PropTypes.func,
  onUserDeleted: PropTypes.func,
  resendDisabled: PropTypes.bool,
  currentUserId: PropTypes.object
};


const mapStateToProps = state => {
  return {
    currentUserId: state.auth.user.UserId,
  };
};

export default connect(
  mapStateToProps,
  null
)(withTranslation()(UserPasswordManager));